import React from "react";
import cn from "classnames";
import styles from './MarketplaceStoreGroup.module.scss';

interface MarketplaceStoreGroupProps {
  size?: 'large' | 'small';
  children?: React.ReactNode;
}

export const MarketplaceStoreGroup: React.FC<MarketplaceStoreGroupProps> = ({
  children,
  size,
}) => {
  return (
    <div
      className={cn(
        styles.group,
        size === "small" && styles.small,
      )}
    >
      {React.Children.toArray(children).reverse()}
    </div>
  );
};
